module.exports = __webpack_public_path__ + "img/35400.82f30c5e.jpg";